import React, { useState } from 'react';
import { KFLButton, KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import Translate from '../shared/localization/localize';
import * as Devices from '../../modules/devices';
import DialogHeader from '../shared/dialog/dialogHeader';
import DialogFooter from '../shared/dialog/dialogFooter';
import { parseFile } from '../../utils';
import useDialog from '../shared/dialog/useDialog';
import './searchFileDialog.scss';
import Logger from '../../libs/logger';


const SearchViaFileDialog: React.FC = () => {
  const {setDialog} = useDialog();
  const [sFile, setSFile] = useState('');

  const filesSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    Array.from(e.target.files).forEach((file: File) => {
      setSFile('');
      Logger.info(['file-selected', file.name]);
      parseFile(file, setSFile);
    });
  };

  const mainSection = (
    <div>
      <div>
        <Translate message={Devices.searchVFileDesc} />
      </div>
      <div>
        <input
          id="searchvf-input"
          className="csv-input"
          type="file"
          accept=".csv"
          onChange={filesSelected}
        />
      </div>
      <div>
        <span>
          <a href="docs/example-file.csv">
            <Translate message={Devices.searchVFileSample} />
          </a>
        </span>
      </div>
    </div>
  );

  const filterButton = (
    <KFLButton
      id="dg-searchvf-bt-filter"
      disabled={!sFile && true}
      onClick={() => Devices.filterViaFile(sFile)}
    >
      <Translate message={Devices.searchVFileApplyBtn} />
    </KFLButton>
  );

  return (
      <KFLDialog
        header={
          <DialogHeader
            title={<Translate message={Devices.searchVFileHeader} />}
            fnCloseDialog={() => setDialog?.()}
          />
        }
        sections={[mainSection]}
        footer={
          <DialogFooter
            buttons={[filterButton]}
            fnCloseDialog={() => setDialog?.()}
          />
        }
      />
  );
};

export default SearchViaFileDialog;
